export default __webpack_public_path__ + "static/media/auto-one-owner.dc6cce73.svg";